/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export const useExpenseStore = defineStore('expenseStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError
    };
  },
  actions: {
    async deleteExpense({
      id
    }) {
      try {
        await axios({
          url: `/expenses/${id}`,
          method: 'DELETE'
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateExpense({
      id,
      body
    }) {
      try {
        await axios({
          url: `/expenses/${id}`,
          method: 'PUT',
          data: body
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getExpense({
      id
    }) {
      try {
        const response = await axios({
          url: `/expenses/${id}`,
          method: 'GET'
        });
        return response.data;
      } catch (error) {
        this.handleError(error);
        return {};
      }
    },
    async getUnassignedExpenses(params) {
      try {
        const response = await axios.get('/expenses', {
          params
        });
        return response.data;
      } catch (error) {
        this.handleError(error);
        return [];
      }
    }
  }
});